import { initializeApp } from "firebase/app";
import { getDatabase, ref, set, onValue } from "firebase/database";
import MountainHouse from "./MountainHouse";

const firebaseConfig = {
  apiKey: "AIzaSyC45hl54cgpDoB_B7iGhtWHtbkVUOgnW58",
  authDomain: "mountain-house-8aaae.firebaseapp.com",
  databaseURL: "https://mountain-house-8aaae-default-rtdb.europe-west1.firebasedatabase.app",
  projectId: "mountain-house-8aaae",
  storageBucket: "mountain-house-8aaae.firebasestorage.app",
  messagingSenderId: "458242953882",
  appId: "1:458242953882:web:abdab7b67c44592ea54523"
};

const firebaseApp = initializeApp(firebaseConfig);
const db = getDatabase(firebaseApp);
window.__FIREBASE_DB__ = { db, ref, set, onValue };

function App() {
  return <MountainHouse />;
}

export default App;
